import { render } from "./ExtendedStockView.vue?vue&type=template&id=68b28d66&scoped=true"
import script from "./ExtendedStockView.vue?vue&type=script&lang=js"
export * from "./ExtendedStockView.vue?vue&type=script&lang=js"

import "./ExtendedStockView.vue?vue&type=style&index=0&id=68b28d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b28d66"]])

export default __exports__